import RoutesApp from './routes';
import { Routes, Route } from 'react-router-dom';
import { useGlobalContext } from './contexts/GlobalContext';
import 'react-toastify/dist/ReactToastify.css';

//Estilos
import './App.css';

//Componentes
import Layout from './pages/layout/Layout';
import Error404 from './pages/404/404';
import LoginContainer from './pages/login/LoginContainer';
import RecoverUserNameContainer from './pages/recoverUserName/RecoverUserNameContainer';
import RequestPasswordContainer from './pages/changePassword/RequestPasswordContainer';
import ChangePasswordContainer from './pages/changePassword/ChangePasswordContainer';
import EmailConfirmation from './pages/emailConfirmation/EmailConfirmation';
import SignupContainer from './pages/signup/SignupContainer';
import { ToastContainer } from 'react-toastify';
import ProfileContainer from './pages/profile/ProfileContainer';
import ChangeOwnPasswordContainer from './pages/changeOwnPassword/ChangeOwnPasswordContainer';
import VineyardsListContainer from './pages/vineyardList/VineyardListContainer';
import VineyardDataContainer from './pages/vineyard/VineyardContainer';
import DJCPListContainer from './pages/DJCPList/DJCPListContainer';
import DJCPContainer from './pages/DJCP/DJCPContainer';
import DJCEContainer from './pages/DJCE/DJCEContainer';
import DJTVContainer from './pages/DJTV/DJTVContainer';
import DJMVContainer from './pages/DJMV/DJMVContainer';
import DJDUVContainer from './pages/DJDUV/DJDUVContainer';
import DJCVContainer from './pages/DJCV/DJCVContainer';
import SettingsContainer from './pages/settings/SettingsContainer';
import NewDJCPContainer from './pages/newDJCP/NewDJCPContainer';
import NewDJCEContainer from './pages/newDJCE/NewDJCEContainer';
import NewDJTVContainer from './pages/newDJTV/NewDJTVContainer';
import NewDJMVContainer from './pages/newDJMV/NewDJMVContainer';
import NewDJDUVContainer from './pages/newDJDUV/NewDJDUVContainer';
import NewDJCVContainer from './pages/newDJCV/NewDJCVContainer';
import ManagersListContainer from './pages/managersList/ManagersListContainer';
import ManagerContainer from './pages/manager/ManagerContainer';
import UsersListContainer from './pages/usersList/UsersListContainer';
import SearchDeclaracionesContainer from './pages/searchDeclaraciones/SearchDeclaracionesContainer';
import SearchGuiasContainer from './pages/searchGuias/SearchGuiasContainer';
import GuiasListContainer from './pages/guiasList/GuiasListContainer';
import GuiaContainer from './pages/guia/GuiaContainer';
import NewGuiaContainer from './pages/newGuia/NewGuiaContainer';
import SearchViniedosContainer from './pages/searchViniedos/SearchViniedosContainer';
import NewGuiaBodegaContainer from './pages/newGuiaBodega/NewGuiaBodegaContainer';
import UserINAVIContainer from './pages/createUserINAVI/UserINAVIContainer';
import GuiaPrint from './pages/guiaPrint/GuiaPrint';
import DJCEListContainer from './pages/DJCEList/DJCEListContainer';
import DJTVListContainer from './pages/DJTVList/DJTVListContainer';
import DJMVListContainer from './pages/DJMVList/DJMVListContainer';
import DJDUVListContainer from './pages/DJDUVList/DJDUVListContainer';
import DJCVListContainer from './pages/DJCVList/DJCVListContainer';
import INAVIHomePageContainer from './pages/INAVIHomePage/INAVIHomePageContainer';
import UserHomePageContainer from './pages/userHomePage/UserHomePageContainer';

function App() {
    const { user } = useGlobalContext();
    return (
        <>
            <ToastContainer hideProgressBar={true} theme={'colored'} />
            <Routes>
                <Route path="*" element={<Error404 />} />
                <Route path={RoutesApp.Login} element={<LoginContainer />} />
                <Route
                    path={RoutesApp.RecoverUserName}
                    element={<RecoverUserNameContainer />}
                />
                <Route
                    path={RoutesApp.RequestNewPassword}
                    element={<RequestPasswordContainer />}
                />
                <Route
                    path={RoutesApp.ConfirmNewPassword}
                    element={<ChangePasswordContainer />}
                />
                <Route
                    path={RoutesApp.ConfirmEmail}
                    element={<EmailConfirmation />}
                />
                <Route path={RoutesApp.Signup} element={<SignupContainer />} />
                <Route
                    path={RoutesApp.Guias.bodega + ':token'}
                    element={<NewGuiaBodegaContainer />}
                />
                <Route
                    path={RoutesApp.Guias.qr + ':token'}
                    element={<GuiaContainer />}
                />
                <Route path={'/printGuia'} element={<GuiaPrint />} />
                <Route path={'/'} element={<Layout />}>
                    {/* Paginas que pueden ver todos los usuarios */}
                    <Route
                        path={RoutesApp.Home}
                        element={
                            user?.tipo === 3 ? (
                                <INAVIHomePageContainer />
                            ) : (
                                <UserHomePageContainer />
                            )
                        }
                    />
                    <Route
                        path={RoutesApp.ChangeOwnPassword}
                        element={<ChangeOwnPasswordContainer />}
                    />
                    <Route
                        path={RoutesApp.Viniedos.single + ':id'}
                        element={<VineyardDataContainer />}
                    />
                    <Route
                        path={RoutesApp.Declaraciones.cosechaProbable + ':id'}
                        element={<DJCPContainer />}
                    />
                    <Route
                        path={
                            RoutesApp.Declaraciones.nuevaCosechaProbable + ':id'
                        }
                        element={<NewDJCPContainer />}
                    />
                    <Route
                        path={RoutesApp.Declaraciones.cosechaEfectiva + ':id'}
                        element={<DJCEContainer />}
                    />
                    <Route
                        path={
                            RoutesApp.Declaraciones.nuevaCosechaEfectiva + ':id'
                        }
                        element={<NewDJCEContainer />}
                    />
                    <Route
                        path={
                            RoutesApp.Declaraciones.transferenciaViniedo + ':id'
                        }
                        element={<DJTVContainer />}
                    />
                    <Route
                        path={
                            RoutesApp.Declaraciones.nuevaTransferenciaViniedo +
                            ':id'
                        }
                        element={<NewDJTVContainer />}
                    />
                    <Route
                        path={
                            RoutesApp.Declaraciones.modificacionViniedo + ':id'
                        }
                        element={<DJMVContainer />}
                    />
                    <Route
                        path={
                            RoutesApp.Declaraciones.nuevaModificacionViniedo +
                            ':id'
                        }
                        element={<NewDJMVContainer />}
                    />
                    <Route
                        path={RoutesApp.Declaraciones.divUnifViniedo + ':id'}
                        element={<DJDUVContainer />}
                    />
                    <Route
                        path={
                            RoutesApp.Declaraciones.nuevaDivUnifViniedo + ':id'
                        }
                        element={<NewDJDUVContainer />}
                    />
                    <Route
                        path={
                            RoutesApp.Declaraciones.cancelacionViniedo + ':id'
                        }
                        element={<DJCVContainer />}
                    />
                    <Route
                        path={
                            RoutesApp.Declaraciones.nuevaCancelacionViniedo +
                            ':id'
                        }
                        element={<NewDJCVContainer />}
                    />
                    <Route
                        path={RoutesApp.Guias.single + ':id'}
                        element={<GuiaContainer />}
                    />
                    <Route
                        path={RoutesApp.Guias.new + ':id'}
                        element={<NewGuiaContainer />}
                    />
                    {/* Paginas que pueden ver solo los usuarios INAVI*/}
                    {user?.tipo === 3 && (
                        <>
                            <Route
                                path={RoutesApp.Viniedos.all}
                                element={<SearchViniedosContainer />}
                            />
                            <Route
                                path={RoutesApp.Declaraciones.all}
                                element={<SearchDeclaracionesContainer />}
                            />
                            <Route
                                path={RoutesApp.Guias.all}
                                element={<SearchGuiasContainer />}
                            />
                            <Route
                                path={RoutesApp.Users.all}
                                element={<UsersListContainer />}
                            />
                            <Route
                                path={RoutesApp.Users.createINAVI + ':id'}
                                element={<UserINAVIContainer />}
                            />
                            <Route
                                path={RoutesApp.Settings}
                                element={<SettingsContainer />}
                            />
                        </>
                    )}
                    {/* Paginas que pueden ver solo los usuarios Productor*/}
                    {user?.tipo === 2 && (
                        <>
                            <Route
                                path={RoutesApp.Managers.all}
                                element={<ManagersListContainer />}
                            />
                            <Route
                                path={RoutesApp.Managers.single + ':id'}
                                element={<ManagerContainer />}
                            />
                        </>
                    )}
                    {/* Paginas que solo pueden ver los usuarios INAVI y Productor */}
                    {user?.tipo !== 1 && (
                        <Route
                            path={RoutesApp.Profile + ':id'}
                            element={<ProfileContainer />}
                        />
                    )}
                    {/* Paginas que pueden ver solo los usuarios Productor y Encargado*/}
                    {user?.tipo !== 3 && (
                        <>
                            <Route
                                path={RoutesApp.Viniedos.all}
                                element={<VineyardsListContainer />}
                            />
                            <Route
                                path={RoutesApp.Declaraciones.cosechaProbable}
                                element={<DJCPListContainer />}
                            />
                            <Route
                                path={RoutesApp.Declaraciones.cosechaEfectiva}
                                element={<DJCEListContainer />}
                            />
                            <Route
                                path={
                                    RoutesApp.Declaraciones.transferenciaViniedo
                                }
                                element={<DJTVListContainer />}
                            />
                            <Route
                                path={
                                    RoutesApp.Declaraciones.modificacionViniedo
                                }
                                element={<DJMVListContainer />}
                            />
                            <Route
                                path={RoutesApp.Declaraciones.divUnifViniedo}
                                element={<DJDUVListContainer />}
                            />
                            <Route
                                path={
                                    RoutesApp.Declaraciones.cancelacionViniedo
                                }
                                element={<DJCVListContainer />}
                            />
                            <Route
                                path={RoutesApp.Guias.all}
                                element={<GuiasListContainer />}
                            />
                        </>
                    )}
                </Route>
            </Routes>
        </>
    );
}

export default App;
